import MNewsAndSeminarRadio from './index.vue';

MNewsAndSeminarRadio.install = app => {
  app.component(MNewsAndSeminarRadio.name, MNewsAndSeminarRadio);
};

export default MNewsAndSeminarRadio;
